import clsx from 'clsx';
import React from 'react';
import { Card } from '../..';

export type StatsGridVariant = 'panel' | 'loose' | 'looseTiles';

type StatsGridProps = {
    stats: React.ReactNode[];
    className?: string;
    /**
     * `panel` — one Card shell; cells share chrome (home / tires).
     * `loose` — layout grid only; each item owns its own surface (e.g. admin navy tiles).
     * `looseTiles` — loose grid with default card bg + primary text on each child.
     */
    variant?: StatsGridVariant;
};

/** Lays out a row of stat tiles. Not the same as `StatusCard` (single left-border accent tile). */
const StatsGrid = ({ stats, className, variant = 'panel' }: StatsGridProps) => {
    const isLoose = variant === 'loose' || variant === 'looseTiles';
    const gridClassName = clsx(
        'stats-grid',
        isLoose && 'stats-grid-loose',
        variant === 'looseTiles' && 'stats-grid-loose-tiles',
        className,
    );

    if (isLoose) {
        return <div className={gridClassName}>{stats}</div>;
    }

    return <Card className={gridClassName}>{stats}</Card>;
};

export default StatsGrid;
